<template>
  <!-- 下载的中间H5 -->
  <div class="download" ref="download"></div>
</template>
<script>
export default {
  name: "download",
  mounted() {
    this.openDownloadUrl()
  },
  methods: {
    downloadFile(url) {
      const a = document.createElement("a")
      const node = this.$refs.download
      a.href = url
      node.appendChild(a)
      a.click()
      node.removeChild(a)
    },
    openDownloadUrl() {
      const { appId, deviceType } = this.$route.params
      this.$ajax
        .get(
          `${this.$apihost}/getAppPublicDownloadAddress.do?appId=${appId}&deviceType=${deviceType}`
        )
        .then(item => {
          if (item.result == 1) {
            const url = item.data.url
            this.downloadFile(url)
          }else {
            this.$message.error('网络异常');
          }
        })
        .catch(() => {
          this.$message.error('网络异常');
        })
    },
  },
}
</script>